"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expectThrow = expectThrow;
exports.expectReject = expectReject;
/**
 * Tiny utility that wraps a function. Use in tests where you expect something
 * to throw.
 *
 * The passed function is called with no parameters. If it returns without
 * throwing, this function throws. If it throws, this function catches and
 * returns the thrown error. The optional second argument can be used to add a
 * bit more info to the error when the function itself fails to throw.
 */
function expectThrow(f, callType = "") {
    const suffix = callType ? " by " + callType : "";
    try {
        f();
        throw new Error(`Expected error to be thrown${suffix}`);
    }
    catch (ex) {
        return ex;
    }
}
/**
 * Tiny utility that wraps a Promise. Use in tests where you expect something
 * to reject.
 *
 * If the passed promise fulfills, this returns one that rejects. If the passed
 * promise rejects, this returns one that fulfills with the error. The optional
 * second argument can be used to add a bit more info to the error when the
 * Promise resolves.
 */
async function expectReject(p, callType = "") {
    const suffix = callType ? " from " + callType : "";
    return p.then(() => {
        throw new Error(`Expected rejected Promise${suffix}`);
    }, (err) => err);
}
//# sourceMappingURL=General.js.map